import { selectPopups } from 'modules/overlay-v2/store/overlay/selectors';
import { useCallback } from 'react';
import { useAppSelector } from 'store/hooks';

export interface PopupMessenger {
  /** Открыто ли хотя бы одно окно оверлея — по нему включаются кнопки синхронизации. */
  hasPopups: boolean;
  /** Отправить команду во все открытые окна: обычное и TV управляются одной панелью. */
  send: (message: object) => void;
}

/**
 * Связь панели управления с окнами оверлея. Команды уходят во все окна сразу, потому что
 * с одной панели открывают и оверлей для OBS, и экран в зале — раньше состояние окна
 * хранилось поштучно, и команды доставались только последнему открытому.
 */
function usePopupMessenger(): PopupMessenger {
  const popups = useAppSelector(selectPopups);

  const send = useCallback(
    (message: object) => {
      const payload = JSON.stringify(message);
      popups.forEach((popup) => {
        if (popup.closed) return;
        popup.postMessage(payload, window.location.origin);
      });
    },
    [popups],
  );

  return { hasPopups: popups.some((popup) => !popup.closed), send };
}

export default usePopupMessenger;
